import { Component, inject, Input, OnDestroy, OnInit } from '@angular/core';
import { Company, CompanyEnum } from '../../models/company.model';
import { ProductsWithPriceAndNoteLabels, ProductWithPriceAndAdditionalInfo } from '../../models/types';
import { Subscription } from 'rxjs/internal/Subscription';
import { BreakpointObserverService } from '@lx/shared/utils-dom';
import { CommonModule } from '@angular/common';
import { PricePipe } from '@lx/shared/ui/pipes';
import { TableModule } from 'primeng/table';

@Component({
  standalone: true,
  imports: [CommonModule, PricePipe, TableModule],
  selector: 'lx-price-lists-portal-price-and-note-table',
  templateUrl: './price-and-note-table.component.html',
  styleUrls: ['./price-and-note-table.component.scss'],
})
export class PriceAndNoteTableComponent implements OnInit, OnDestroy {
  @Input() company: Company = CompanyEnum.KIL;
  @Input() dataSource: ProductWithPriceAndAdditionalInfo[] = [];
  @Input() columnLabels: ProductsWithPriceAndNoteLabels | undefined;

  private readonly breakpointObserverService = inject(BreakpointObserverService);
  private subscriptions = new Subscription();

  isMobile = true;
  priceColumnWidth = '20%';

  ngOnInit(): void {
    this.subscriptions.add(
      this.breakpointObserverService.isMobile$.subscribe((isMobile) => {
        this.isMobile = isMobile;
        if (this.isMobile) {
          this.priceColumnWidth = '20%';
        } else {
          this.priceColumnWidth = '15%';
        }
      }),
    );
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  getAdditionalInfoList(additionalInfo: string | string[]): string[] {
    if (!additionalInfo) {
      return [];
    }
    return [].concat(additionalInfo);
  }
}
